import { render, staticRenderFns } from "./OrgProfitStatement.vue?vue&type=template&id=17f5a5a9&scoped=true"
import script from "./OrgProfitStatement.vue?vue&type=script&lang=js"
export * from "./OrgProfitStatement.vue?vue&type=script&lang=js"
import style0 from "./OrgProfitStatement.vue?vue&type=style&index=0&id=17f5a5a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f5a5a9",
  null
  
)

export default component.exports